import { CognitoIdentityProviderClient } from '@aws-sdk/client-cognito-identity-provider'

export const cognitoClient = new CognitoIdentityProviderClient({
  endpoint: process.env.NEXT_PUBLIC_AWS_COGNITO_ENDPOINT,
  region: process.env.NEXT_PUBLIC_AWS_COGNITO_REGION,
})
